import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "./index.css";
import App from "./App";
import { store } from "./store";
import AuthBootstrap from "./components/AuthBootstrap";

createRoot(document.getElementById("root")!).render(
    <StrictMode>

        <GoogleOAuthProvider
            clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}
        >

            <Provider store={store}>

                <BrowserRouter>

                    <AuthBootstrap>

                        <App />

                    </AuthBootstrap>

                </BrowserRouter>

            </Provider>

        </GoogleOAuthProvider>

    </StrictMode>
);